import { render, staticRenderFns } from "./index.vue?vue&type=template&id=af5600bc&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\webproject\\haoyu\\wms-web\\WMS\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af5600bc')) {
      api.createRecord('af5600bc', component.options)
    } else {
      api.reload('af5600bc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=af5600bc&", function () {
      api.rerender('af5600bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parse/3-5/index.vue"
export default component.exports